// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-control {
  padding-left: 0;
}

input.form-control {
  height: unset;
}

.wrapper {
  box-sizing: border-box;
}
.wrapper #day,
.wrapper #month,
.wrapper #year {
  box-shadow: none;
  border: 0;
  font-size: 1.4rem;
  text-align: center;
  padding-top: 6px;
  padding-bottom: 5px;
  width: 100%;
}
.wrapper:focus-within {
  border-color: #005aa3;
  box-shadow: 0 0 0 0.2rem rgba(38, 139, 220, 0.5);
}
.wrapper.is-valid:focus-within {
  border-color: #112a3e;
  box-shadow: 0 0 0 0.2rem rgba(2, 136, 68, 0.25);
}`, "",{"version":3,"sources":["webpack://./libs/msslib/src/lib/components/formly/fields/date-input/date-input.component.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;AADF;;AAIA;EACE,aAAA;AADF;;AAIA;EACE,sBAAA;AADF;AAGE;;;EAGE,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AADJ;AAIE;EACE,qBAAA;EACA,gDAAA;AAFJ;AAKE;EACE,qBAAA;EACA,+CAAA;AAHJ","sourcesContent":["@use 'mssvariables' as *;\n\n.form-control {\n  padding-left: 0;\n}\n\ninput.form-control {\n  height: unset;\n}\n\n.wrapper {\n  box-sizing: border-box;\n\n  #day,\n  #month,\n  #year {\n    box-shadow: none;\n    border: 0;\n    font-size: 1.4rem;\n    text-align: center;\n    padding-top: 6px;\n    padding-bottom: 5px;\n    width: 100%;\n  }\n\n  &:focus-within {\n    border-color: #005aa3;\n    box-shadow: 0 0 0 0.2rem rgba(38, 139, 220, 0.5);\n  }\n\n  &.is-valid:focus-within {\n    border-color: theme-color('success');\n    box-shadow: 0 0 0 0.2rem rgba(2, 136, 68, 0.25);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
